import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBbqFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does barbecue food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `What types of barbecue can a food ${vehicleType} serve at my event?`,
    answer: `Texas-style brisket and sausage, Carolina pulled pork, ribs, smoked chicken, and burnt ends, with sides like mac and cheese, slaw, and beans. Many ${vehicleType}s make their own rubs and sauces.`
  },
  {
    question: `Are barbecue food ${vehicleType}s a good choice for corporate events and large groups?`,
    answer: `Yes. Smoked meat is cooked ahead and plates fast, so lines move even with a big crowd, and it's familiar enough to work for mixed groups. Ask each ${vehicleType} how many guests it can serve per hour and how far ahead it needs a final guest count.`
  },
  {
    question: `Can barbecue food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Many offer vegetarian or plant-based options and gluten-free sides. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `How far in advance should I book a barbecue food ${vehicleType} for catering?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function BbqFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBbqFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BbqFaq;
